import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { IDripFeeder } from './types';

const path = '/user-service/dripFeeder';

export const requestUpdateDripFeeder = <T extends { id?: string; rank?: number }>(data: T): Promise<void> => {
  return mutate(path, async() => {
    try {
      await axios.patch(`${path}/${data.id}`, data);
      Notistack.successMessage('Drip Feeder - Updated Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

export const requestCreateDripFeeder = (data: IDripFeeder) => {
  return mutate(path, async() => {
    try {
      await axios.post(path, data);
      Notistack.successMessage('Drip Feeder - Created Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

export const requestDeleteDripFeeder = (data: IDripFeeder) => {
  return mutate(path, async() => {
    try {
      await axios.delete(`${path}/${data.id}`);
      Notistack.successMessage('Drip Feeder - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateGlobalSettings = (data: { id: string; time: string }) => {
  return mutate('/user-service/dripFeeder/dripFeederGlobalSetting', async() => {
    try {
      await axios.patch(`/user-service/dripFeeder/dripFeederGlobalSetting/${data.id}`, { time: data.time });
      Notistack.successMessage('Global Settings Time - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
